import styled from 'styled-components';
import { red, white } from '@avangard/ui/colors';

type TextWithCountProps = {
    children: React.ReactNode;

    count?: number;
};

const TextWithCount = (props: TextWithCountProps): React.ReactElement => {
    const { count = 0, children } = props;

    return (
        <Root>
            {children}
            {count > 0 ? <Counter>{count}</Counter> : null}
        </Root>
    );
};

const Root = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
`;

const Counter = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    margin-inline-start: 8px;

    width: 20px;
    height: 20px;

    color: ${white[100]};
    font-size: 1.2rem;
    font-weight: 500;

    background-color: ${red[100]};
    border-radius: 50%;
`;

export { TextWithCount };
